import { createFileRoute, Link } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { useIsAdmin } from '@/lib/hooks/use-is-admin';
import { ForbiddenScreen } from '@/components/organisms/forbidden-screen';
import { ErrorState } from '@/components/molecules/error-state';
import { Button } from '@/components/atoms/button';

function AdminSplat(): ReactElement {
  const isAdmin = useIsAdmin();
  if (!isAdmin) return <ForbiddenScreen />;
  return (
    <ErrorState
      title="Page not found"
      description="That admin route doesn't exist yet."
      action={
        <Link to="/">
          <Button size="lg" fullWidth>
            Back to dashboard
          </Button>
        </Link>
      }
    />
  );
}

export const Route = createFileRoute('/admin/$')({
  component: AdminSplat,
});
